import React from 'react';

import editIcon from 'images/icons/invite/edit.svg';
import deleteIcon from 'images/icons/invite/delete.svg';

import { useAdminContext } from '../../../../contexts/AdminContext';

export default function Actions({ row }) {
  const { dispatch, actions } = useAdminContext();

  const editAdmin = (e, row) => {
    actions.showEditForm(dispatch, row);
  };

  const deleteAdmin = (e, row) => {
    swal(
      {
        title: '',
        text: 'Do you want to delete this admin user?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        closeOnConfirm: true,
        closeOnCancel: true,
      },
      (isConfirm) => {
        if (isConfirm) {
          let el = e.target;
          while (el && el.tagName !== 'A') {
            el = el.parentNode;
          }

          el.innerHTML = '<i class="fa fa-spinner fa-spin"></i>';
          actions.deleteAdmin(dispatch, row.id);
        }
      },
    );
  };

  return (
    <div>
      <a onClick={(e) => editAdmin(e, row)} className="mr10">
        <img src={editIcon} />
      </a>
      {row.attributes.id != '0' && (
        <a onClick={(e) => deleteAdmin(e, row)}>
          <img src={deleteIcon} />
        </a>
      )}
    </div>
  );
}
